console.log(`mode=${process.env.VUE_APP_MODE}`);
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";
// import "fetch-polyfill";

import VueMoment from "vue-moment";
import moment from "moment";
import utils from "./mixin/utils";

import axios from "axios";
import { Service } from "axios-middleware";
import "./registerServiceWorker";

import firebase from "firebase";

import VueLocalStorage from "vue-local-storage";

// console.log(process.env);
var firebaseConfig = {
  apiKey: `${process.env.VUE_APP_FIREBASE_API_KEY}`,
  authDomain: `${process.env.VUE_APP_FIREBASE_AUTH_DOMAIN}`,
  projectId: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}`,
  storageBucket: `${process.env.VUE_APP_FIREBASE_STORAGE_BUCKET}`,
  messagingSenderId: `${process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID}`,
  appId: `${process.env.VUE_APP_FIREBASE_APP_ID}`,
};

// console.log(firebaseConfig);

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

let messaging = null;
console.log("firebase.messaging.isSupported");
console.log(firebase.messaging.isSupported());
if (firebase.messaging.isSupported()) {
  console.log("++B");
  messaging = firebase.messaging();
  // not fire
  self.addEventListener("notificationclick", function(event) {
    console.log("+++ notification open");
    console.log(event);
    // log send to server
  });

  // fired
  self.addEventListener("notificationclose", function(event) {
    console.log("+++ notification close");
    console.log(event);
    // log send to server
  });
  messaging
    .getToken({
      vapidKey: `${process.env.VUE_APP_FIREBASE_VAPID_KEY}`,
    })
    .then(currentToken => {
      if (currentToken) {
        console.log(`currentToken=${currentToken}`);
        // sendTokenToServer(currentToken);
        // updateUIForPushEnabled(currentToken);
      } else {
        // Show permission request.
        console.log(
          "No registration token available. Request permission to generate one.",
        );
        // Show permission UI.
        // updateUIForPushPermissionRequired();
        // setTokenSentToServer(false);
      }
    })
    .catch(err => {
      console.log("An error occurred while retrieving token. ", err);
      // showToken("Error retrieving registration token. ", err);
      // setTokenSentToServer(false);
    });
}
// console.log("++C");

const service = new Service(axios);

service.register({
  onRequest(config) {
    // console.log("onRequest");
    return config;
  },
  onSync(promise) {
    // console.log("onSync");
    return promise;
  },
  onResponse(response) {
    // console.log("onResponse");
    return response;
  },
  onResponseError(error) {
    console.log("onResponseError");
    console.log(error.response.status);
    if (error.response.status == "401") {
      // router.push({ name: "/logout" });

      store.dispatch("auth/logout");
      router.push("/login");
    }
    return error;
  },
});

Vue.config.productionTip = false;

moment.locale("ja");
Vue.use(VueMoment, {
  moment,
});

Vue.use(VueLocalStorage);

Vue.mixin(utils);

import { default as msalPlugin } from "vue-msal-browser";
const msalConfig = {
  auth: {
    tenant: process.env.VUE_APP_MS_TENANT,
    clientId: process.env.VUE_APP_MS_CLIENT_ID,
    authority: process.env.VUE_APP_MS_AUTHORITY,
    redirectUri: process.env.VUE_APP_MS_REDIRECT_URI,
    postLogoutRedirectUri: process.env.VUE_APP_MS_POST_LOGOUT_REDIRECT_URI,
    scopes: JSON.parse(process.env.VUE_APP_MS_SCOPES),
  },
  cache: {
    cacheLocation: "localStorage",
  },
  graph: {
    url: process.env.VUE_APP_MS_GRAPH_URL,
    scopes: JSON.parse(process.env.VUE_APP_MS_SCOPES),
    response_type: "blob",
  },
  mode: "redirect",
};
Vue.use(msalPlugin, msalConfig);

router.beforeEach((to, from, next) => {
  // if (!to.currentUser) next({ name: "login" });
  // else next();
  // console.log("beforeEach");
  // console.log(to.name);
  if (to.name.toLowerCase() == "signup") {
    next();
  } else if (
    !store.state.auth.status.loggedIn &&
    to.name != "login" &&
    to.name != "login-magic-number" &&
    to.name != "sso"
  ) {
    next({ name: "login" });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
